const A = 40;
export {
  A as SAVE_LIST_NAME_MAX_CHARACTERS
};
//# sourceMappingURL=savedLists.es.js.map
